import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';


import Select   from 'react-select'
import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';
import _ from 'lodash';

var statusMap = [
    {value:'Active', label: 'Active'},
    {value:'Inactive', label: 'Inactive'},
]

export default class AdminQualityCheckSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.subcategoriesList =  _.sortBy(prepareSelectOptionsList(
            _.filter(this.props.allCategories,function (category) {
                return category.AncestorCategories.length > 0
            }),
            {
                label: 'CategoryName',
                value: '_id'
            }), 'label')
        this.categoriesList = _.sortBy(prepareSelectOptionsList(
            _.filter(this.props.allCategories,function (category) {
                return category.AncestorCategories.length == 0
            }),
            {
                label: 'CategoryName',
                value: '_id'
            }), 'label')
        var selectedCategory = ''
        if (!_.isUndefined(this.props.location.query.Category)){
            var foundCategory =  _.find(this.props.allCategories, function (category) {
                return  category.AncestorCategories.length == 0 &&  this.props.location.query.Category == category.TagName
            }.bind(this))
            if ( foundCategory) {
                selectedCategory = foundCategory._id
                this.subcategoriesList =  _.sortBy(prepareSelectOptionsList(
                    _.filter(this.props.allCategories,function (category) {
                        return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories,'CategoryID'), selectedCategory)
                    }),
                    {
                        label: 'CategoryName',
                        value: '_id'
                    }), 'label')
            }
        }
        var selectedSubcategory = ''
        if (!_.isUndefined(this.props.location.query.Subcategory)){
            var foundCategory =  _.find(this.props.allCategories, function (category) {
                return  category.AncestorCategories.length > 0 &&  this.props.location.query.Subcategory == category.TagName
            }.bind(this))
            selectedSubcategory = foundCategory? foundCategory._id:''
        }





        /* Brand  and Model*/
      //  this.brandsList =  this.props.allBrandsWithModels
        var allModels= []
        if (_.isUndefined(this.props.location.query.Brand)){
        _.forEach(this.props.allBrandsWithModels,function (record) {
            allModels  = _.concat(allModels,record.Models)
        })
        }else{
            var foundItem = _.find(this.props.allBrandsWithModels, {value:this.props.location.query.Brand})
            allModels =_.get( foundItem,  'Models',[])
        }

        this.modelsList = _.sortBy(prepareSelectOptionsList(
            _.map(allModels,model=>{
                return {label:model, value:model}}),
            {
                label: 'label',
                value: 'value'
            }), 'label')

        this.state = {
            filterOptions: {
                selectedCategory:selectedCategory,
                selectedSubcategory:selectedSubcategory,
                Brand:this.props.location.query.Brand,
                Model:this.props.location.query.Model,
                perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                Statuses:  _.isUndefined(this.props.location.query.Statuses) ?  [] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (status) {
                    return _.find(statusMap, {value:status})
                }) : [_.find(statusMap, {value:this.props.location.query.Statuses})],            }
        };
    };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (!_.isUndefined(filterOptions.Statuses)) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }
        if (filterOptions.Category ) {
            queryParams.Category = filterOptions.Category;
        }

         if (!_.isUndefined(this.props.location.query.ItemNumbers)) {
            queryParams.ItemNumbers = Array.isArray(this.props.location.query.ItemNumbers) ?  this.props.location.query.ItemNumbers : [this.props.location.query.ItemNumbers];
        }
        if (filterOptions.Subcategory ) {
            queryParams.Subcategory = filterOptions.Subcategory;
        }
        if (filterOptions.Brand ) {
            queryParams.Brand =filterOptions.Brand
            queryParams.Brands = [filterOptions.Brand]
        }
        if (filterOptions.Model ) {
            queryParams.Model =filterOptions.Model
            queryParams.Models = [filterOptions.Model]
        }

        console.log('queryparams', queryParams  );
        return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onCategoryChange(option) {
        var selectedSubcategory = this.state.filterOptions.selectedSubcategory,
            Subcategory = this.state.filterOptions.Subcategory;
        if (option){
            this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.props.allCategories,function (category) {
                    return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories,'CategoryID'), option.value)
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label')
            var foundSelectedSubcategory = _.find( this.subcategoriesList, function (subcategoryOption) {
                return subcategoryOption.value == selectedSubcategory
            })

            if (!foundSelectedSubcategory){
                selectedSubcategory = '';
                Subcategory = ''
            }
        } else {
            this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.props.allCategories,function (category) {
                    return category.AncestorCategories.length > 0
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label');
        }
        this.setState({
                'filterOptions': {
                    ...this.state.filterOptions,
                    selectedCategory:   option ? option.value : '',
                    selectedSubcategory:selectedSubcategory,
                    Subcategory:Subcategory,
                    Category: option ? _.find(this.props.allCategories, function (category) {
                        return   option.value == category._id
                    })['TagName'] : '',
                },
            },
            function () {
                this.props.search();
            });
    }

    onSubcategoryChange(option) {

        this.setState({
                'filterOptions': {
                    ...this.state.filterOptions,
                    selectedSubcategory:   option ? option.value : '',
                    Subcategory: option ? _.find(this.props.allCategories, function (category) {
                        return   option.value == category._id
                    })['TagName'] : '',
                },
            },
            function () {
                this.props.search();
            });
    }

    onBrandChange(selectedOption) {
        var allModels= []
        if (selectedOption){
            var foundItem = _.find(this.props.allBrandsWithModels, {value:selectedOption.value})
            allModels =_.get( foundItem,  'Models',[])
        } else {
            _.forEach(this.props.allBrandsWithModels, function (record) {
                allModels = _.concat(allModels, record.Models)
            })
        }
        console.log('allModels', allModels  );
            this.modelsList = _.sortBy(prepareSelectOptionsList(
                _.map(allModels,model=>{
                    return {label:model, value:model}}),
                {
                    label: 'label',
                    value: 'value'
                }), 'label')
 
        this.setState({
            'filterOptions': {
                ...this.state.filterOptions,
                Brand:selectedOption ? selectedOption.value:null,
            }
        }, function () {
            this.props.search();
        });
    }

    onModelChange(selectedOption) {

        var allModels= [],foundItem
        if (selectedOption){
              foundItem = _.find(this.props.allBrandsWithModels,item=>{
                return _.includes(item.Models,selectedOption.value)
            })

        }

console.log('foundItem', foundItem  );


        this.setState({
            'filterOptions': {
                ...this.state.filterOptions,
                Brand:foundItem?foundItem.value:this.state.filterOptions.Brand,
                Model:selectedOption ? selectedOption.value:null,
            }
        }, function () {
            this.props.search();
        });
    }



    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
        var self = this;
         return (
            <div className="product-search-block">
                {/*<Row className="show-grid">*/}
                    {/*<Col md={4} xs={4} className="top10">*/}
                        {/*<Button className="btn btn-primary" onClick={this.props.onSelectAllRecordsChange}>*/}
                            {/*{ this.props.adminQualityChecks.selectedRecords.length ? 'Clear selection' : 'Select all' }*/}
                        {/*</Button>*/}
                    {/*</Col>*/}
                {/*</Row>*/}
                <Row  >

                    <Col md={3} xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                </Row>
                <Row  >

                    {/*<Col md={3} xs={3} className="top10">*/}
                    {/*<Select*/}
                    {/*tabIndex="0"*/}
                    {/*placeholder="Per Page"*/}
                    {/*clearable={false}*/}
                    {/*options={config.perPageSelectOptions}*/}
                    {/*onChange={this.onFilterChange.bind(this)}*/}
                    {/*value={self.state.filterOptions.perPage}*/}
                    {/*/>*/}
                    {/*</Col>*/}

                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Brand"
                            clearable={true}
                            options={this.props.allBrandsWithModels}
                            onChange={this.onBrandChange.bind(this)}
                            value={self.state.filterOptions.Brand}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Models"
                            clearable={true}
                            options={this.modelsList}
                            onChange={this.onModelChange.bind(this)}
                            value={self.state.filterOptions.Model}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Category"
                            clearable={true}
                            options={this.categoriesList}
                            onChange={this.onCategoryChange.bind(this)}
                            value={self.state.filterOptions.selectedCategory}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Subcategory"
                            clearable={true}
                            options={this.subcategoriesList}
                            onChange={this.onSubcategoryChange.bind(this)}
                            value={self.state.filterOptions.selectedSubcategory}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            clearable={true}
                            multi
                            placeholder="Status"
                            options={ _.map(statusMap, function (item) {
                                return {value: item.value, label: item.label}
                            })}
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Statuses: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Statuses}
                        />

                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                    <Col md={3} xs={6} className="pull-right top10">
                        <button className="pull-right btn btn-primary" onClick={(event) => self.props.addNewRecord()}
                                type="button">
                            Add
                        </button>
                    </Col>
                </Row>

            </div>
        );

    }
}



